import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {finalize} from "rxjs/operators";
import {SnipcartItem} from "../../services/student-snipcart.service";
import {environment} from "../../../environments/environment";
import {Utils} from "../../services/utils/utils";
import {orderBuilder, SimpleOrder} from "../../model/transactional.v2";
import {ModalComponent} from '../modal/modal.component';
import {V3School} from "../../model/v3/schools";
import { TransactionsV3RestService } from "../../services/rest/v3/transactions-rest.service";
import { SchoolCheckoutRequestInput } from "../../model/v3/transactions";

@Component({
    selector: 'app-buy-credits-cart',
    templateUrl: './buy-credits-cart.component.html',
    styleUrls: ['./buy-credits-cart.component.css'],
    standalone: false
})
export class BuyCreditsCartComponent implements OnInit {
  private _school: V3School;
  private initialized = false;

  @ViewChild("creditsCart", {static: true})
  modal: ModalComponent;
  currentCart: {[productId: string]: number} = {};
  loading = false;

  @Input()
  set school(school: V3School) {
    this._school = school;
    this.init();
  }

  get school(): V3School {
    return this._school;
  }

  products = [
    new SnipcartItem(null,
      "CreditEn.r3.10PCK",
      "Callan English 3rd Edition eBook pack",
      "10 credits",
      101.50, null, null,
      null),
    new SnipcartItem(null,
      "CreditSP.10PCK",
      "Callan Español eBook pack",
      "10 credits",
      111.50, null, null,
      null),
    new SnipcartItem(null,
      "CreditCfk.10PCK",
      "Callan for Kids eBook pack",
      "10 credits (full Lesson content, without activities)",
      134.50, null, null,
      null),
    new SnipcartItem(null,
      "CreditBs.1PCK",
      "Callan for Business eBook",
      "1 credit (sold individually)",
      15.95, null, null,
      null)
  ];

  constructor(
    private transactionsRest: TransactionsV3RestService
  ) { }

  ngOnInit() {
  }

  private init() {
    if (!this._school) return;
    if (!this.initialized) {
      this.reloadCart();
      this.initialized = true;
    }
  }

  show() {
    this.modal.show();
    this.reloadCart();
  }

  getCurrency() {
    return "£";
  }

  add(product: SnipcartItem, value: number) {
    let quantity = this.currentCart[product.id];
    if (quantity == null) {
      quantity = 0;
    }
    quantity += value;
    if (quantity < 0) return;
    this.currentCart[product.id] = quantity;
  }

  getQuantity(product: SnipcartItem) {
    const quantity = this.currentCart[product.id];
    if (!quantity) return 0;
    return quantity;
  }

  private reloadCart() {
    this.currentCart = {};
  }

  public checkout() {
    this.loading = true;

    const order = this.mapToOrder();
    const request = this.mapToSchoolCheckoutRequestInput(order);

    this.transactionsRest.createSchoolCheckout(
      null,
      `${environment.serverBase}/school/${this._school.id}/payment/confirm`,
      `${environment.serverBase}/school/${this._school.id}/payment/cancel`,
      `${environment.serverBase}/school/${this._school.id}/payment/cancel`,
      request
    ).pipe(
      finalize( () => {
        this.loading = false
        this.hide();
      })
    ).subscribe(
      checkoutUrl => {
        window.location.href = checkoutUrl
      }
    )

  }

  private hide() {
    this.modal.hide();
  }

  getProductPrice(product: SnipcartItem) {

    return `${this.getCurrency()}${Utils.padToCurrency(product.price)}`;
  }

  private mapToOrder(): SimpleOrder {
    const builder = orderBuilder();
    this.products.map( product => ({
      product,
      quantity : this.currentCart[product.id]
    }))
      .filter( row => row.quantity)
      .forEach( row => {
        builder.newEntry(row.product.id, row.quantity)
          .withPrice("regular", row.product.price, "gbp")
          .allowQuantityAdjust().finish()
      })
    return builder.build();
  }

  private mapToSchoolCheckoutRequestInput(order: SimpleOrder): SchoolCheckoutRequestInput {
    const entries = (order.entries || [])
      .filter(entry => entry?.quantity)
      .map(entry => ({
        product: { mappedId: entry.price?.variant?.code },
        amount: entry.quantity,
        itemPrice: entry.price?.value,
        currency: entry.price?.currency,
        description: null
      }));
    return {
      school: { id: this._school.id },
      entries
    };
  }
}
